import { createAsyncThunk } from '@reduxjs/toolkit'
import { SCSNQuotationController } from 'features/RequestForQuotations/Quotation/SCSNQuotationController'
import { RootAppState } from 'store/configureStore'

export const sendToSCSN = createAsyncThunk<
  Promise<void>,
  null,
  { state: RootAppState }
>('project/sendToSCSN', async (_args, thunkAPI) => {
  const scsnController = new SCSNQuotationController()

  const projectId = thunkAPI.getState().project.activeProject?.id

  if (!projectId) {
    throw new Error('No active project found')
  }

  return scsnController.sendToSCSN(projectId)
})
